module.exports = __webpack_public_path__ + "img/OHA-logo.f412cf2d.png";